export const appContextActions = {
  SET_USER: 'SET_USER',
  SET_NOTIFICATION_COUNT: 'SET_NOTIFICATION_COUNT',
  SET_ENUMS: 'SET_ENUMS',
  SET_BREAD_CRUMBS: 'SET_BREAD_CRUMBS',
  SET_BACK_NAVIGATION: 'SET_BACK_NAVIGATION',
  SET_AUTHORIZED: 'SET_AUTHORIZED',
  SET_SIGNED_IN: 'SET_SIGNED_IN',
};
